import React from "react";
import { secureStorage } from "../../../utils/secureStorage";
import { useMemo } from "react";
import { useAuth } from "../../../utils/useAuth";

const BookingPDFSample = () => {
  const FormData = useMemo(
    () => secureStorage.getItem("TourBookingInfo") || {},
    [],
  );
  const { isLoggedIn, user } = useAuth();
  const hotelInfo = useMemo(() => secureStorage.getItem("hotelInfo") || {}, []);

  return (
    <>
      <div className="w-[700px] mx-auto border p-3">
        <div className="space-y-10">
          <div className="flex justify-between items-center border-b ">
            <div className="w-[180px] h-auto">
              <img
                src="https://dhoorbin.com/static/media/logo.97db35fdd8dc77bfc4a65d78b6155a86.svg"
                alt=""
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <p className="text-sm font-bold text-end">
                Your World of Travel, <br /> just one click away!
              </p>
            </div>
          </div>
          <div>
            <p className="text-sm">Congratulations!🎉, {user.fullName}</p>
            <p className="text-sm">
              For choosing us as your travel partner, we are really glad to see
              your booking. You have successfully booked your tour with us.
            </p>
          </div>
          <div className="flex justify-center flex-col items-center">
            <p className="text-sm font-bold">
              Tour Details ({FormData.invoiceId})
            </p>
            <small>
              Please show this email at your tour coordinators for confirmation
            </small>
          </div>
          <div>
            <table className="w-full">
              <thead>
                <tr className="border-b">
                  <th className="p-1 border text-sm">Booking ID</th>
                  <th className="p-1 border text-sm">Transaction ID</th>
                  <th className="p-1 border text-sm">Tour Name</th>
                  <th className="p-1 border text-sm">Duration</th>
                  <th className="p-1 border text-sm">Paid Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="p-1 border text-sm">{FormData.invoiceId}</td>
                  <td className="p-1 border text-sm">
                    {FormData.transactionId}
                  </td>
                  <td className="p-1 border text-sm">{FormData.tourName}</td>
                  <td className="p-1 border text-sm">
                    {FormData.startDate.split("T")[0]} to{" "}
                    {FormData.endDate.split("T")[0]}
                  </td>
                  <td className="p-1 border text-sm">
                    {FormData.totalAmount.toFixed(0)} BDT
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <p className="text-sm">
              We look forward to welcoming you at {FormData.tourName}. If you
              have any questions, please contact us at +8809639203838 or
              hello@dhoorbin.com
            </p>
          </div>
          <div className="bg-gray-100 px-2 py-0.5 rounded-lg">
            <p className="text-xs">
              This invoice has been generated by Dhoorbin electronically! If you
              misuse will be your responsility
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingPDFSample;
